import {
  CAM_DOC_MANAGER_MAIN_VIEW_TABLE_ID,
  CAM_DOC_MANAGER_STUDENT_VIEW_TABLE_ID,
  CAM_DOC_MANAGER_COLLEGE_VIEW_TABLE_ID,
} from 'modules/CollegeApplicationManager/pages/DocumentManagerList/constants';
import {
  IPPM_CANDIDATE_TABLE_ID,
  IPPM_OPPORTUNITY_TABLE_ID,
  IPPM_PLACEMENT_TABLE_ID,
} from 'modules/IndustryPartnerProgramManagement/constants';
import { STUDENT_LIST_DATA_TABLE_ID } from 'modules/StudentList/constants';

export const MIN_WIDTHS = {
  CHECKBOX: 40,
  TEXT: 96,
  TEXT_ICON: 116,
  CHIPS: 144,
  USER: 176,
  CAM_APP_COUNTS: 80,
  BADGE: 46,
  COLLEGE: 228,
  TRANSCRIPT_CENTER: {
    DOCUMENT_TYPE: 120,
  },
};

export const WIDTHS = {
  HISTORICAL_RECORDS: {
    DEFAULT: 88,
  },
};

export const MAX_WIDTHS = {
  TRANSCRIPT_CENTER: {
    DATE: 90,
    SCORE: 80,
    NOTE: 54,
    DOC_ID: 86,
    ACTION: 124,
    REQUESTER: 96,
    DESTINATION: 224,
    DELIVERY_METHOD: {
      TABLET: 54,
      DESKTOP: 92,
    },
  },
  CAM: {
    ACTION: 88,
  },
};

export const ASCENDING = 'asc';
export const DESCENDING = 'desc';

export const CHECKBOX_COLUMN_ID = 'select';
export const ACTIONS_COLUMN_ID = 'actions';

export const PERSISTED_SORT_STORAGE_KEY = 'persistedDataTableV2Sort';
// IDs should follow the format <PAGE_DESCRIPTION_DATA_TABLE_ID>
export const PERSISTED_SORT_IDS = [
  STUDENT_LIST_DATA_TABLE_ID,
  CAM_DOC_MANAGER_MAIN_VIEW_TABLE_ID,
  CAM_DOC_MANAGER_STUDENT_VIEW_TABLE_ID,
  CAM_DOC_MANAGER_COLLEGE_VIEW_TABLE_ID,
  IPPM_CANDIDATE_TABLE_ID,
  IPPM_OPPORTUNITY_TABLE_ID,
  IPPM_PLACEMENT_TABLE_ID,
];
